import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!user) {
    return <Navigate to="/login-registration" replace />;
  }

  return children;
};

export const AdminRoute = ({ children }) => {
  const { user, role, loading } = useAuth();

  if (loading) return null;

  if (!user) {
    return <Navigate to="/login-registration" replace />;
  }

  if (role !== 'admin') {
    return <Navigate to="/project-dashboard" replace />;
  }

  return children;
};
